import "@pdfslick/react/dist/pdf_viewer.css";
import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainForm from "./components/oldFront/form/MainForm";
import RequestManagement from "./components/oldFront/request/RequestManagement";
import ViabilityForm from "./components/oldFront/viability/ViabilityForm";
import RequestStatus from "./components/oldFront/requestStatus/RequestStatus";
import CommerceLoggin from "./components/oldFront/feasibility/Feasibility";
import CreateCommerceView from "./components/oldFront/commerce/CreateCommerceView";
import QuotaSimulator2 from "./components/oldFront/quotaSimulator/QuotaSimulator";
import GeneralCommerce from "./components/newFront/generalCommerce/GeneralCommerce";
import LoginCommerce from "./components/newFront/loginCommerce/LoginCommerce";
import CommerceForm from "./components/newFront/commerceForm/CommerceForm";
import InProcessCredit from "./components/newFront/inProcessCredit/InProcessCredit";
import QuotaSimulator from "./components/newFront/quotaSimulator/QuotaSimulator";
import UploadFiles from "./components/newFront/uploadFiles/UploadFiles";
import LoginAdmin from "./components/newFront/loginAdmin/LoginAdmin";
import DownloadPagare from "./components/newFront/downloadFiles/DownloadPagare";
import CreditsToApprove from "./components/newFront/creditsToApprove/creditsToApprove";
import BuildingPage from "./components/oldFront/buildingPage/BuildingPage";
import GeneralAdmin from "./components/newFront/generalAdmin/GeneralAdmin";
import PendingViabilities from "./components/newFront/pendingViabilities/PendingViabilities";
import CreateCommerce from "./components/newFront/createCommerce/CreateCommerce";
import ViabilityStudy from "./components/newFront/viabilityStudy/ViabilityStudy";
import ViabilityStudyByDocument from "./components/newFront/viabilityStudy/ViabilityStudyByDocument";
import ModifyParameters from "./components/newFront/modifyParameters/ModifyParameters";
import Statistics from "./components/newFront/statistics/Statistics";
import Cobranza from "./components/newFront/cobranza/Cobranza";
import CobranzaDetail from "./components/newFront/cobranza/CobranzaDetail";
import GestionCartera from "./components/newFront/gestionCartera/GestionCartera";
import GestionCarteraCliente from "./components/newFront/gestionCartera/GestionCarteraCliente";
import GestionCarteraCredito from "./components/newFront/gestionCartera/GestionCarteraCredito";
import LandingPage from "./components/newFront/landingPage/LandingPage";
import Comercio from "./components/newFront/comercios/Comercio";
import ValidacionFacturas from "./components/newFront/comercios/ValidacionFacturas";
import ValidacionFacturaDetalle from "./components/newFront/comercios/ValidacionFacturaDetalle";
import Incentivos from "./components/newFront/comercios/Incentivos";
import Sucursales from "./components/newFront/sucursales/Sucursales";
import Reportes from "./components/newFront/reportes/Reportes";
import ValidacionInformes from "./components/newFront/validacionInformes/ValidacionInformes";
import { HomeAdmin } from "./components/newFront/homeAdmin/HomeAdmin";
import Clientes from "./components/newFront/clientes/Clientes";
import Fondeador from "./components/newFront/fondeadores/Fondeador";
import CrearCreditos from "./components/newFront/registroCreditos/CrearCreditos";
import Creditos from "./components/newFront/registroCreditos/Creditos";
import Steppers from "./components/newFront/solicitudes/Steppers";
import Solicitud from "./components/newFront/solicitudes/Solicitud";
import DocumentoPdfExperian from "./components/newFront/solicitudes/DocumentoPdfExperian";
import Policy from "./components/newFront/policy/Policy";
import PolicySegmentation from "./components/newFront/policy/PolicySegmentation";
import Asignaciones from "./components/newFront/asignaciones/Asignaciones";
import Conversacion from "./components/newFront/conversaciones/Conversacion";
import EliminarCredit from "./components/newFront/eliminarCreditos/EliminarCredito";
import Information from "./components/newFront/information/Information";
import NovedadesSiigo from "./components/newFront/novedadesSiigo/NovedadesSiigo";
import CreateCommerceForm from "./components/newFront/createCommerceForm/CreateCommerceForm";
import EditCommerceForm from "./components/newFront/editCommerceForm/EditCommerceForm";
import ChatCobranza from "./components/newFront/chatCobranza/ChatCobranza";
import StepperOption from "./components/newFront/solicitudes/StepperOption";
import SolicitudV4 from "./components/newFront/solicitudes/SolicitudV4";
import SolicitudV4Detail from "./components/newFront/solicitudes/SolicitudV4Detail";
import ConversacionV4 from "./components/newFront/solicitudes/conversacionV4/ConversacionV4";
import Scores from "./components/newFront/scores/Scores";
import FlujosWhatsappList from "./components/newFront/flujosWhatsapp/FlujosWhatsappList";
import FlujosWhatsappEditor from "./components/newFront/flujosWhatsapp/FlujosWhatsappEditor";
import FlujosWhatsappSegmentaciones from "./components/newFront/flujosWhatsapp/FlujosWhatsappSegmentaciones";
import FlujosWhatsappSegmentacionNueva from "./components/newFront/flujosWhatsapp/FlujosWhatsappSegmentacionNueva";
import Campanas from "./components/newFront/campanas/Campanas";
import ExpedicionCertificados from "./components/newFront/expedicionCertificados/ExpedicionCertificados";
import ContabilidadSiigo from "./components/newFront/contabilidadSiigo/ContabilidadSiigo";
import Condonaciones from "./components/newFront/condonaciones/Condonaciones";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/commerce-loggin" element={<CommerceLoggin />} />
          <Route path="/feasibility" element={<MainForm />} />
          <Route path="/pending" element={<RequestManagement />} />
          <Route path="/quota-simulatorss" element={<QuotaSimulator2 />} />
          <Route path="/viability-form" element={<ViabilityForm />} />
          <Route path="/request-status" element={<RequestStatus />} />
          <Route
            path="/create-commerce-view"
            element={<CreateCommerceView />}
          />

          <Route path="/" element={<LoginCommerce />} />
          <Route path="/admin" element={<LoginAdmin />} />
          <Route path="/commerce" element={<GeneralCommerce />} />
          <Route path="/commerce-form" element={<CommerceForm />} />
          <Route path="/inprocess-credits" element={<InProcessCredit />} />
          <Route path="/quota-simulator" element={<QuotaSimulator />} />
          <Route path="/upload-files" element={<UploadFiles />} />
          <Route path="/download-pagare" element={<DownloadPagare />} />
          <Route path="/credits-to-review" element={<CreditsToApprove />} />
          <Route path="/building" element={<BuildingPage />} />
          <Route path="/general-admin" element={<GeneralAdmin />} />
          <Route path="/pending-viabilities" element={<PendingViabilities />} />
          <Route path="/create-commerce" element={<CreateCommerce />} />
          <Route path="/viability-study" element={<ViabilityStudy />} />
          <Route path="/landing-page" element={<LandingPage />} />
          <Route path="/homeAdmin" element={<HomeAdmin />}>
            <Route path="dashboard" element={<Statistics />} />
            <Route path="cobranza" element={<Cobranza />} />
            <Route path="chat-cobranza" element={<ChatCobranza />} />
            <Route path="cobranza-detail" element={<CobranzaDetail />} />
            <Route path="gestion-cartera" element={<GestionCartera />} />
            <Route
              path="gestion-cartera/clientes/:clientUuid"
              element={<GestionCarteraCliente />}
            />
            <Route
              path="gestion-cartera/clientes/:clientUuid/creditos/:creditUuid"
              element={<GestionCarteraCredito />}
            />
            <Route path="chat-cobranza" element={<ChatCobranza />} />
            <Route path="comercios" element={<Comercio />} />
            <Route path="comercios/facturas" element={<ValidacionFacturas />} />
            <Route path="comercios/incentivos" element={<Incentivos />} />
            <Route
              path="comercios/facturas/:invoiceUuid"
              element={<ValidacionFacturaDetalle />}
            />
            <Route
              path="sucursales/:nameCommerce/:uuidCommerce"
              element={<Sucursales />}
            />
            <Route path="modify-parameters" element={<ModifyParameters />} />
            <Route path="novedades-siigo" element={<NovedadesSiigo />} />
            <Route path="flujos-whatsapp/segmentaciones/nueva" element={<FlujosWhatsappSegmentacionNueva />} />
            <Route path="flujos-whatsapp/segmentaciones" element={<FlujosWhatsappSegmentaciones />} />
            <Route path="flujos-whatsapp/nuevo" element={<FlujosWhatsappEditor />} />
            <Route path="flujos-whatsapp/:flowUuid" element={<FlujosWhatsappEditor />} />
            <Route path="flujos-whatsapp" element={<FlujosWhatsappList />} />
            <Route path="reportes" element={<Reportes />} />
            <Route path="validacion-informes" element={<ValidacionInformes />} />
            <Route path="clientes" element={<Clientes />}></Route>
            <Route path="viability-study-by-document" element={<ViabilityStudyByDocument />}></Route>
            <Route path="fondeadores" element={<Fondeador />}></Route>
            <Route path="gestion-manual" element={<Creditos />}></Route>
            <Route
              path="/homeAdmin/solicitudes"
              element={<Solicitud />}
            ></Route>
            <Route
              path="solicitudes/experian"
              element={<DocumentoPdfExperian />}
            ></Route>
            <Route
              path="solicitudes/detail/:uuid"
              element={<Steppers></Steppers>}
            ></Route>
            <Route
              path="solicitudes/detail/option/:uuid"
              element={<StepperOption></StepperOption>}
            ></Route>
            <Route path="solicitudes/v4" element={<SolicitudV4 />} />
            <Route
              path="solicitudes/v4/detail/:uuid"
              element={<SolicitudV4Detail />}
            />
            <Route
              path="solicitudes/v4/conversacion/:kind/:identifier"
              element={<ConversacionV4 />}
            />
            <Route path="politicas" element={<Policy></Policy>}></Route>
            <Route
              path="segmentation"
              element={<PolicySegmentation></PolicySegmentation>}
            ></Route>
            <Route
              path="asignaciones"
              element={<Asignaciones></Asignaciones>}
            ></Route>
            <Route
              path="conversaciones/client/:documentClient"
              element={<Conversacion></Conversacion>}
            ></Route>
            <Route
              path="conversaciones/commerce/:cellphone"
              element={<Conversacion></Conversacion>}
            ></Route>
            <Route
              path="eliminar-creditos"
              element={<EliminarCredit></EliminarCredit>}
            ></Route>
            <Route
              path="create-commerce-form"
              element={<CreateCommerceForm></CreateCommerceForm>}
            ></Route>
            <Route
              path="edit-commerce-form/:commerceUuid"
              element={<EditCommerceForm></EditCommerceForm>}
            ></Route>
            <Route
              path="documentos/clientes/:clientUuid"
              element={<Information></Information>}
            ></Route>
            <Route path="scores" element={<Scores></Scores>}></Route>
            <Route 
            path="campanas"
            element={<Campanas></Campanas>}>
            </Route>
            <Route
              path="expedicion-certificados"
              element={<ExpedicionCertificados />}
            />
            <Route
              path="contabilidad-siigo"
              element={<ContabilidadSiigo />}
            />
            <Route path="condonaciones" element={<Condonaciones />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
